import {getCardTypeWithPrefix} from './getCardTypeBasedOnPrefix';

export const calculateMaskWhenCardTypeValidForChunking = (cardNumber) => {
  if (/^4/.test(cardNumber)) {
    return '9999 9999 9999 9999';
  } if (/^222[1-9]|^22[3-9][0-9]|^2[3-6][0-9][0-9]|^27[0-1][0-9]|^2720/.test(cardNumber)) {
    return '9999 9999 9999 9999';
  } if (/^3[47]/.test(cardNumber)) {
    return '9999 999999 99999';
  } if (/^5[1-5]/.test(cardNumber)) {
    return '9999 9999 9999 9999';
  }
  return calculateMaskWhenCardTypeInvalidForChunking(cardNumber);
};

export const calculateMaskWhenCardTypeInvalidForChunking = (cardNumber) => {
  if (getCardTypeWithPrefix(cardNumber) === 'amex') {
    return '999999999999999';
  }
  return '9999999999999999';
};
